import { render, staticRenderFns } from "./ContestView.vue?vue&type=template&id=f0147ca2&lang=pug&"
import script from "./ContestView.vue?vue&type=script&lang=js&"
export * from "./ContestView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports